export const actionTypePrefix = '@@watch';
export const reduxKey = '@@watch';
